import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Page, Card, Form, TextField, FormLayout, Button, Banner } from '@shopify/polaris';

import Logo from 'images/logo.png';

const propTypes = {
  record: PropTypes.object.isRequired,
  submitURL: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,

  errors: PropTypes.shape({
    password: PropTypes.array,
    password_confirmation: PropTypes.array,
  }),
}

const defaultProps = {

}

const UserInvitationEdit = (props) => {
  const [errors, setErrors] = useState(props.errors);

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const { record } = props;
  const csrfToken = document.querySelector("meta[name=csrf-token]").content;

  const handlePasswordChange = (v) => {
    setPassword(v);
    setErrors({ ...errors, password: null });
  }

  const handlePasswordConfirmationChange = (v) => {
    setPasswordConfirmation(v);
    setErrors({ ...errors, password_confirmation: null });
  }

  console.log("R", props);
  return (
    <AppProvider>
      <Page>
        
        <div className="mb20 flex justifyCenter">
          <img src={ Logo } height="40px" />
        </div>
        { errors && errors.invitation_token &&
          <Banner
            title="Error"
            status="critical"
          >
            La invitación a es inválida o ha expirado.
          </Banner>
        }
        <form action={ props.submitURL } method="post" >
          <Card 
            title="Completar registro" sectioned
          >
            <FormLayout>
              <input type="hidden" name="authenticity_token" value={ csrfToken } />
              <input name="_method" type="hidden" value="put" />
              <input name="user[invitation_token]" hidden value={ props.token } readOnly />

              <TextField
                name="user[password]"
                value={ password }
                onChange={ handlePasswordChange }
                type="password"
                label={ I18n.t("activerecord.attributes.user.password") }
                error={ errors && errors.password }
              />
              
              <TextField 
                name="user[password_confirmation]"
                value={ passwordConfirmation }
                onChange={ handlePasswordConfirmationChange }
                type="password"
                label={ I18n.t("activerecord.attributes.user.password_confirmation") } 
                error={ errors && errors.password_confirmation }
              />

              <Button primary submit >
                { I18n.t("actions.submit") }
              </Button>
            </FormLayout>
          </Card>
        </form>
      </Page>
    </AppProvider>
  )
};

UserInvitationEdit.propTypes = propTypes;
UserInvitationEdit.defaultProps = defaultProps;

export default UserInvitationEdit;